import React from "react";
import styled from "styled-components";
import { Switch } from "@blueprintjs/core";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Beta } from "@components";

type Props = {
  title: string;
  description: string;
  warning?: string;
  value: boolean;
  beta?: boolean;
  disabled?: boolean;
  onChange: () => void;
};

export const ItemHeading = styled.div`
  display: flex;
  font-size: var(--global-font-size-m);
  margin-top: var(--global-spacing-l);
`;

export const ItemSubheading = styled.div`
  font-size: var(--global-font-size-xs);
  color: var(--global-mid-gray);
`;

const StyledSwitch = styled(Switch)`
  display: inline-block;
  margin-left: var(--global-spacing-m);
  margin-bottom: 0;
`;

export const SettingSwitch: React.FC<Props> = ({
  title,
  description,
  warning,
  value,
  onChange,
  beta = false,
  disabled = false,
}) => {
  return (
    <div>
      <ItemHeading>
        {title}
        {beta && <Beta />}
        <StyledSwitch checked={value} onChange={onChange} disabled={disabled} />
      </ItemHeading>
      <ItemSubheading>{description}</ItemSubheading>
      {warning && (
        <ItemSubheading>
          <FontAwesomeIcon icon={faExclamationTriangle} /> {warning}
        </ItemSubheading>
      )}
    </div>
  );
};
